// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#NewTask__Component[data-v-5f49cac4] {\n  top: 144px;\n  left: 582px;\n}\n", ""]);
// Exports
module.exports = exports;
